import "./menuitem.css";
export type MenuItemProps = {
  value: string;
  onClicked?: () => void;
};

const MenuItem: React.FC<MenuItemProps> = ({ value, onClicked }) => {
  return (
    <div
      className="menu-item"
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      onClick={(e) => {
        if (onClicked) {
          e.stopPropagation();
          onClicked();
        }
      }}
    >
      <div className="overlay"></div>
      <span className="title-small value">{value}</span>
    </div>
  );
};

export default MenuItem;
